// Banner fijo de "Ver como" — visible SIEMPRE que la sesión sea impersonada
// (owner viendo la app con los ojos de un usuario). Salir restaura la sesión original.
// ⚠️ Regla práctica: usar para VER; las acciones quedan a nombre del usuario visto.
import { createPortal } from 'react-dom';
import { Eye, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { stopImpersonation } from '../features/users/api';

export default function ImpersonationBanner() {
  const { user, impersonator } = useAuth();
  if (!impersonator || !user) return null;

  const exit = async () => {
    try { await stopImpersonation(); } catch { /* la sesión pudo expirar: recargar manda a login */ }
    window.location.href = '/';
  };

  return createPortal(
    <div className="fixed inset-x-0 bottom-0 z-[80] flex justify-center pb-[calc(0.75rem+env(safe-area-inset-bottom))] pointer-events-none">
      <div className="pointer-events-auto flex items-center gap-2.5 rounded-full border border-amber-500/50 bg-amber-500 px-4 py-2 text-sm font-semibold text-black shadow-xl">
        <Eye size={16} />
        <span>Viendo como {user.firstname} {user.lastname}</span>
        <button onClick={exit}
          className="ml-1 flex items-center gap-1 rounded-full bg-black/80 px-2.5 py-1 text-xs font-semibold text-white transition hover:bg-black">
          <LogOut size={12} /> Volver a mi cuenta
        </button>
      </div>
    </div>,
    document.body
  );
}
